const trackScreen = require('./src/services/analytics').trackScreen;
require('./src/layouts/index.css');

exports.onRouteUpdate = (state) => {
  trackScreen(state.location.pathname);
};
